import { GQL_RoundingTypeEnum } from "@/queries/global";
import Decimal from "@/utils/decimal";

export const sum = (arr: Decimal[]) =>
  arr.reduce((s, amount) => s.add(amount), new Decimal(0));

export const roundAmount = (
  amount: Decimal,
  rounding: GQL_RoundingTypeEnum,
) => {
  let roundedAmount: Decimal;

  switch (rounding) {
    case 'DISABLED':
      roundedAmount = amount;
      break;
    case 'UP':
      roundedAmount = amount.toDecimalPlaces(0, Decimal.ROUND_UP);
      break;
    case 'DOWN':
      roundedAmount = amount.toDecimalPlaces(0, Decimal.ROUND_DOWN);
      break;
    case 'NEAREST':
      roundedAmount = amount.toDecimalPlaces(0);
      break;
    default:
      throw new Error(`Invalid option ${rounding} passed to calculation.roundAmount().`);
      break;
  }

  return roundedAmount;
};
